module.exports = __webpack_public_path__ + "img/sql.49cffdd2.png";